import React, { useEffect } from "react";
import { connect } from "react-redux";
import { Form } from "antd";
import DrawerForm from "components/form";
import { bindActionCreators, Dispatch } from "redux";
import { Creators as LobbyActions } from "store/lobby/lobby-duck";
import { IRegisterActiveItem, IProcessesData, IDocumentsData, ISaleChannelData, IDocumentType, PlateFormatType } from "store/lobby/lobby-model";
import { DrawerStatusEnum } from "typings/global.types";
import { mountRegisterFormValues } from "utils/form/saleChannel";

interface IPropsViewRegister {
  form?: any;
  saleChannelActive?: number;
  inboundProcessesList: IProcessesData[];
  salesChannelList?: ISaleChannelData[];
  documentsList: IDocumentsData[];
  drawerIsLoading?: boolean;
  isLoading?: boolean;
  registerActive?: IRegisterActiveItem;
  hasSaleChannel: boolean;
  visibleDrawerViewRegister: boolean;
  visibleDrawerViewMode: DrawerStatusEnum;
  documentType: IDocumentType;
  plateFormatType: PlateFormatType;
}

interface IDispatchProps {
  lobbyDocumentsFetchAsync?: (...args) => void;
  lobbyUpdateFormModified: (...args) => void;
  lobbyProcessActive: (...args) => void;
  lobbySaleChannelActive: (...args) => void;
  lobbyUpdateStepEntryPermissionStatus?: (...args) => void;
  lobbyUpdateEntryPermissionActive?: (...args) => void;
  lobbyFetchEntryPermissionAsync?: (...args) => void;
}

export type IViewRegister = IPropsViewRegister & IDispatchProps;

export const ViewRegister = ({
  form,
  registerActive,
  hasSaleChannel,
  visibleDrawerViewMode,
  visibleDrawerViewRegister,
  inboundProcessesList,
  documentsList,
  documentType,
  salesChannelList,
  saleChannelActive,
  drawerIsLoading,
  plateFormatType,
  lobbyUpdateFormModified,
  lobbySaleChannelActive,
  lobbyProcessActive,
  lobbyDocumentsFetchAsync,
  lobbyUpdateStepEntryPermissionStatus,
  lobbyUpdateEntryPermissionActive,
  lobbyFetchEntryPermissionAsync,
}: IViewRegister) => {
  useEffect(() => {
    if (registerActive?.id) {
      form.setFieldsValue(mountRegisterFormValues(registerActive, hasSaleChannel, salesChannelList, visibleDrawerViewMode === DrawerStatusEnum.Edit));
    }
  }, [registerActive, hasSaleChannel, salesChannelList, visibleDrawerViewMode]);

  return (
    <Form.Provider
      onFormChange={(_, info) => {
        const { changedFields } = info;
        const changedFileldsSize = changedFields?.length || 0;
        if (changedFileldsSize === 1) {
          lobbyUpdateFormModified(true);
        }
      }}
    >
      <DrawerForm
        form={form}
        disabledFields={visibleDrawerViewMode === DrawerStatusEnum.View}
        documentsList={documentsList}
        lobbyDocumentsFetchAsync={lobbyDocumentsFetchAsync}
        registerActive={registerActive}
        carrierRef={null}
        lobbyProcessActive={lobbyProcessActive}
        inboundProcessesList={inboundProcessesList}
        hasSaleChannel={hasSaleChannel}
        lobbySaleChannelActive={lobbySaleChannelActive}
        salesChannelList={salesChannelList}
        visibleDrawerView={visibleDrawerViewRegister}
        visibleDrawerAddNewRegister={false}
        disabledPlate={true}
        visibleDrawerViewMode={visibleDrawerViewMode}
        drawerIsLoading={drawerIsLoading}
        documentType={documentType}
        hasEntryPermission={false}
        saleChannelActive={saleChannelActive}
        lobbyUpdateStepEntryPermissionStatus={lobbyUpdateStepEntryPermissionStatus}
        lobbyUpdateEntryPermissionActive={lobbyUpdateEntryPermissionActive}
        lobbyFetchEntryPermissionAsync={lobbyFetchEntryPermissionAsync}
        plateFormatType={plateFormatType}
      />
    </Form.Provider>
  );
};

const mapDispatchToActions = (dispatch: Dispatch) => bindActionCreators({ ...LobbyActions }, dispatch);

const mapStateToProps = (state) => ({
  isLoading: state.Lobby.isLoading,
  drawerIsLoading: state.Lobby.drawerIsLoading,
  registerActive: state.Lobby.registerActive,
  visibleDrawerViewRegister: state.Lobby.visibleDrawerViewRegister,
  visibleDrawerViewMode: state.Lobby.visibleDrawerViewMode,
  salesChannelList: state.Lobby.salesChannelList,
  inboundProcessesList: state.Lobby.inboundProcessesList,
  hasSaleChannel: state.Lobby.hasSaleChannel,
  documentsList: state.Lobby.documentsList,
  documentType: state.Lobby.documentType,
  saleChannelActive: state.Lobby.saleChannelActive,
  plateFormatType: state.Lobby.plateFormatType,
});

export default connect(mapStateToProps, mapDispatchToActions)(ViewRegister);
